<template>
  <input-base
    :name="name"
    :label="label"
    :errorMessage="errorMessage"
    :meta="meta"
  >
  <select
    @blur="handleBlur"
    @change="changeValue" class="form-control" :value="selectedKey">
      <option
        v-for="opt in opts"
        :value="opt.key"
      >
        {{opt.name}}
      </option>
    </select>
  </input-base>
</template>

<script>
import { ref } from "vue"
import InputBase from "@/components/layout/forms/Input.vue"
import { useField } from "vee-validate"

export default {
  components: {
    InputBase,
  },
  props: {
    modelValue: {
      type: String,
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    includeBlank: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    const {
      value: selectedKey,
      errorMessage,
      handleChange,
      handleBlur,
      meta,
    } = useField(props.name || props.label, undefined, {
      initialValue: props.modelValue,
    })


    function changeValue(val) {
      handleChange(val)
      emit('update:modelValue', val)
    }

    const opts = [...(props.options)]
    if (props.includeBlank)
      opts.unshift({name: '', key: ''})

    return {
      changeValue,
      handleBlur,
      meta,
      errorMessage,
      selectedKey,
      opts,
    }
  },
}
</script>

<style scoped>
</style>
